import { render, staticRenderFns } from "./ActiveMembersAgeWiseReport.vue?vue&type=template&id=e0082b40"
import script from "./ActiveMembersAgeWiseReport.vue?vue&type=script&lang=js"
export * from "./ActiveMembersAgeWiseReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports